import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} 粵語主頁`,
    languageButtonLabel: `語言`,
    languageModalTitle: `揀語言`,
    languageModalCloseLabel: `收埋語言選單`,
  },
  languageOptions: {
    'en-US': {
      label: `英文`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `英文（肯亞）`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `英文（奈及利亞）`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `英文 (新加坡)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `葡萄牙文`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `德文`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `西班牙文`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `法文`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `意大利文`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `荷蘭文`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `北歐／波羅的海語`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `日文`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `韓文`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `普通話`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `廣東話`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `泰文`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `印地語`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `波斯文`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `俄文`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `阿拉伯文`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `摩洛哥阿拉伯文`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `揀語言`,
    closeLabel: `收埋語言選單`,
  },
  languageHint: (ctx) => `一鍵切換 ${ctx.localesCount}+ 種語言版本。`,
  readPagePrompt: ({languageLabel}) => `用${languageLabel}閱讀此頁面。`,
};
